/** @format */
import { SisStateDeclaration } from 'sis-components';
import { TimingComponent } from './timing.component';

export const states: SisStateDeclaration[] = [
    {
        name: 'student.logged-in.plan.timing',
        url: '/timing',
        component: TimingComponent,
        data: {
            hideLastNode: false,
            showHome: true,
            browserTabTitle: 'APPLICATION_TIMING',
        },
        headerParams: {
            displayNameKey: 'APPLICATION_TIMING',
        },
    },
];
